import { gql } from '@apollo/client';

export default gql`
  query loggedIn {
    loggedIn {
      id
      name
      email
      roles
    }
  }
`;
